<template>
	<component :key="key" :is="formModule.component" :name="formModule.name"  :title="formModule.title" :id="formModule.id" />
</template>
<style scoped>


</style>
<script>
	import reportBase from '@_system/components/base/report.js'
	import loginMixins from '@_system/components/base/mixins/login/login.js'
	export default {
		mixins: [reportBase,loginMixins],
		props: {
			penetrateConfig: {
				type: Object,
				default: () => {
					return {
						name: '',
						title: '穿透',
						penetrateName: '穿透',
						id: 0,
					}
				}
			},

		},
		data() {
			return {
				demoshow: true,
				key: Math.random(),
				moduleName: this.penetrateConfig.name,
				exportData: [],
				loading: false,
				show: false
			}
		},
		watch: {

		},
		computed: {
			penetrateMap() {
				return this.$store.state.penetrateMap
			}
		},
		created() {
		
			//this.formModule = this.penetrateConfig
		},
		mounted() {
			if (!this.$store.state.system.systemdata) {
				this.login_init()
			}else{
				this.login_handle()
			}
		},
		methods: {
			login_after() {
				this.load()
			},	
			load() {
				if (this.penetrateMap[this.penetrateConfig.name]) {
					window.document.title = this.penetrateConfig.title
					this.init()
				} else {
					this.$emit('back', 'cancle')
					this.$message.error('穿透对象路径不存在')
				}
			},
			initList() {

			},
			init() {
				import(`@/${this.penetrateMap[this.penetrateConfig.name]}`).then((res) => {
					this.formModule = {
						component: res.default,
						name: this.penetrateConfig.name,
						title:this.penetrateConfig.title,
						id:this.penetrateConfig.id
					}
					console.log(this.formModule)
					
				})
			},
			formBack(e) {
				this.$emit('back', e)
			}
		}
	}
</script>
